import '../node_modules/axios/index.js';
import { NRLogger } from '../modules/newRelic.js';
import { getFunctionName } from '../utils/Utils.js';
import axios from '../node_modules/axios/lib/axios.js';

const fetchLocalizedUrls=async(tenant,locale,urlId)=>{const url=`https://url.prod.merch.vpsvc.com/v3/url/${tenant}/${locale}/${urlId}?requestor=SelfServiceUI`;try{const result=await axios.get(url);return (result==null?void 0:result.data)||null}catch(err){var _e_response;const e=err;NRLogger.error("SS-UI Get Localized URL",{message:"Get site config - Error while getting site config",status:(_e_response=e.response)==null?void 0:_e_response.status,uri:url,urlId,tenant,locale,handler:getFunctionName()});return null}};

export { fetchLocalizedUrls };
//# sourceMappingURL=localizedUrls.service.js.map
